/* eslint-disable jquery/no-css */
/* eslint-disable jquery/no-class */
/* eslint-disable no-unused-vars */
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from 'lightgallery/plugins/zoom';
import PinchZoom from 'pinch-zoom-js';
import $ from 'jquery';
import { isLG } from '../../util/domutils';
import videoPlayer from './videoPlayer';

export const GLOBALS = {
  PINCH_ZOOM: [],
  PINCH_ZOOM_TOGGLED: false,
  PLUGIN: null,
};

export const EVENTS = {
  PINCH_ZOOM_START: 'pz_zoomstart',
  PINCH_ZOOM_END: 'pz_zoomend',
};

const SELECTORS = {
  GALLERY: '.main-gallery-inner',
  IMAGE_WRAPPER: '.primary-images__image-wrapper',
  TOOLBAR: '.lg-toolbar',
  SLIDE: '.lg-item',
  MAIN_IMAGE: '.lg-image',
};

export const PDP_GALLERY_EVENTS = {
  OPEN: 'gallery:open',
};

const addMouseMoveNewEvent = (image) => {
  const container = image.closest('.lg-img-wrap');
  const zoomInBtn = document.getElementById('zoom-in');
  const zoomOutBtn = document.getElementById('zoom-out');
  let scale = 3;
  let panX = 0;
  let panY = 0;
  if (!image || !container) return;

  function clampPan() {
    if (scale <= 1) {
      panX = 0;
      panY = 0;
      return;
    }
    const imgRect = image.getBoundingClientRect();
    const contRect = container.getBoundingClientRect();

    const excessX = Math.max(0, (imgRect.width - contRect.width) / 2);
    const excessY = Math.max(0, (imgRect.height - contRect.height) / 2);

    panX = Math.min(excessX, Math.max(-excessX, panX));
    panY = Math.min(excessY, Math.max(-excessY, panY));
  }

  function removeFullzoomClass() {
    if (image.classList.contains('fullZoomed')) {
      image.classList.remove('fullZoomed');
    }
  }

  function removeZoomedOutClass() {
    if (image.classList.contains('zoomed-out')) {
      image.classList.remove('zoomed-out');
    }
  }

  function updateTransform() {
    if (scale <= 1) {
      // Perfectly centered, no pan offset at scale 1
      image.style.transform = 'translate(0%, 0%) scale(1)';
      removeFullzoomClass();
      image.classList.add('zoomed-out');
      zoomInBtn.disabled = false;
      zoomOutBtn.disabled = true;
    } else {
      clampPan();
      if (scale === 1.5) {
        image.style.transform = `translate(calc(0% + ${panX}px), calc(25% + ${panY}px)) scale(${scale})`;
        removeFullzoomClass();
        removeZoomedOutClass();
        zoomOutBtn.disabled = false;
        zoomInBtn.disabled = false;
      } else if (scale === 2) {
        image.style.transform = `translate(calc(0% + ${panX}px), calc(50% + ${panY}px)) scale(${scale})`;
        removeFullzoomClass();
        removeZoomedOutClass();
        zoomInBtn.disabled = false;
        zoomOutBtn.disabled = false;
      } else if (scale === 2.5) {
        image.style.transform = `translate(calc(0% + ${panX}px), calc(75% + ${panY}px)) scale(${scale})`;
        removeFullzoomClass();
        removeZoomedOutClass();
        zoomInBtn.disabled = false;
        zoomOutBtn.disabled = false;
      } else if (scale === 3) {
        image.style.transform = `translate(calc(0% + ${panX}px), calc(100% + ${panY}px)) scale(${scale})`;
        image.classList.add('fullZoomed');
        removeZoomedOutClass();
        zoomOutBtn.disabled = false;
        zoomInBtn.disabled = true;
      }
    }
  }

  // On image load initialized.
  updateTransform();

  image.addEventListener('click', (e) => {
    switch (scale) {
      case 1.5:
        scale = 2;
        break;
      case 2:
        scale = 2.5;
        break;
      case 2.5:
        scale = 3;
        break;
      case 3:
        scale = 1;
        break;
      default:
        scale = 1.5;
        break;
    }
    updateTransform();
  });

  const handleMove = (e) => {
    if (scale <= 1) return; // Only allow panning when zoomed

    let clientY = null;
    // eslint-disable-next-line prefer-destructuring
    if (e.type === 'mousemove') {
      // eslint-disable-next-line prefer-destructuring
      clientY = e.clientY;
    } else if (e.type === 'touchmove' && e.touches && e.touches.length > 0) {
      // eslint-disable-next-line prefer-destructuring
      clientY = e.touches[0].clientY;
      e.preventDefault(); // Prevent scrolling
    }

    if (clientY === null) return;

    const toolbar = document.querySelector(SELECTORS.TOOLBAR);
    const lgComponents = document.querySelector('.lg-components');
    const toolbarHeight = toolbar.clientHeight + lgComponents.clientHeight || 0;

    const containerRect = container.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();

    const containerHeights = containerRect.height;
    const imageHeight = imageRect.height;

    const availablePanY = Math.max(0, imageHeight - containerHeights);
    const mouseY = clientY - containerRect.top - toolbarHeight;

    const percent = Math.min(1, Math.max(0, mouseY / containerHeights));
    const offsetY = availablePanY * percent + (availablePanY * percent) / 10;

    // Switch logic based on zoom level
    let translateY = '0%';
    switch (scale) {
      case 1.5:
        translateY = `calc(25% - ${offsetY}px)`;
        break;
      case 2:
        translateY = `calc(50% - ${offsetY}px)`;
        break;
      case 2.5:
        translateY = `calc(75% - ${offsetY}px)`;
        break;
      case 3:
        translateY = `calc(100% - ${offsetY}px)`;
        break;
      default:
        translateY = `calc(0% - ${offsetY}px)`;
        break;
    }

    image.style.transform = `translate(calc(0% + ${panX}px), ${translateY}) scale(${scale})`;
  };

  container.addEventListener('mousemove', handleMove);
  container.addEventListener('touchmove', handleMove, { passive: false });

  zoomInBtn.addEventListener('click', () => {
    scale = Math.min(3, scale + 0.5);
    if (image.closest('.lg-current')) {
      updateTransform();
    }
  });

  zoomOutBtn.addEventListener('click', () => {
    if (scale <= 1) return;
    scale = Math.max(1, scale - 0.5);
    if (scale === 1) {
      scale = 1;
      panX = 0;
      panY = 0;
    }
    if (image.closest('.lg-current')) {
      updateTransform();
    }
  });
};

const addMouseMoveEvent = (image) => {
  if (image) {
    image.style.top = '0';
    image.addEventListener('mousemove', (mouseEvent) => {
      const toolbar = document.querySelector(SELECTORS.TOOLBAR);

      const imgHeight = image.clientHeight;
      const windowHeight = window.outerHeight;
      const toolbarHeight = (toolbar && toolbar.clientHeight) || 0;
      const mouseY = mouseEvent.clientY - toolbarHeight;

      const verticalOffsetPercent = (mouseY / windowHeight) * 100;
      const imageOffset = (imgHeight / 100) * verticalOffsetPercent;
      const calculatedOffset = Math.min(imgHeight - windowHeight, imageOffset);

      image.style.top = `-${calculatedOffset}px`;
    });

    image.dataset.scrollInitialized = 'true';
  }
};

const initGallery = (container) => {
  const enableZoomControls = container.dataset.zoomControls ? container.dataset.zoomControls === 'true' : false;
  const enableDesktopControls = container.dataset.desktopnav ? container.dataset.desktopnav === 'true' : false;
  const enableMobileControls = container.dataset.mobilenav ? container.dataset.mobilenav === 'true' : false;
  const enableThumnails = container.dataset.thumbnails ? container.dataset.thumbnails === 'true' : false;

  document.querySelectorAll(SELECTORS.IMAGE_WRAPPER).forEach((imageWrapper) => {
    imageWrapper.dataset.width = window.outerWidth;
  });

  // eslint-disable-next-line prefer-const
  let plugin = lightGallery(container, {
    plugins: [lgZoom, lgThumbnail, lgVideo],
    licenseKey: container.dataset.key,
    thumbnail: enableThumnails,
    enableDrag: false,
    download: false,
    controls: enableDesktopControls,
    actualSize: false,
    counter: false,
    autoplayVideoOnSlide: container.dataset.autoplayvideo === 'true',
    gotoNextSlideOnVideoEnd: container.dataset.gotonextslideonvideoend === 'true',
    zoomFromOrigin: false,
    zoom: false,
    preload: 4,
    mobileSettings: {
      showCloseIcon: true,
      controls: enableMobileControls,
      swipeToClose: false, // Prevent swipe-down to close on mobile
      tapToClose: false,
      actualSize: true,
    },
    vimeoPlayerParams: {
      controls: true,
      loop: container.dataset.playvideoinloop === 'true',
      autopause: true,
      autoPlay: container.dataset.autoplayvideo === 'true',
      responsive: true,
    },
  });

  container.addEventListener('lgBeforeOpen', () => {
    document.dispatchEvent(new CustomEvent(PDP_GALLERY_EVENTS.OPEN));
  });

  container.addEventListener('lgAfterOpen', () => {
    const maincontainer = document.querySelectorAll('.lg-container');
    if (maincontainer.length > 1) {
      maincontainer[0].remove();
    }
  });

  container.addEventListener('lgAfterSlide', () => {
    const zoomIn = document.querySelector('.lg-zoom-in');
    if (zoomIn) {
      zoomIn.classList.remove('inactive');
    }
  });

  container.addEventListener('lgSlideItemLoad', () => {
    const slides = document.querySelectorAll(`${SELECTORS.SLIDE}`);
    slides.forEach((slide) => {
      const image = slide && slide.querySelector(SELECTORS.MAIN_IMAGE);
      if (container.dataset.newpdp && image) {
        if (isLG()) {
          addMouseMoveNewEvent(image);
        } else {
          // eslint-disable-next-line no-lonely-if
          if (image && image.offsetHeight && !image.dataset.initialized) {
            // eslint-disable-next-line no-use-before-define
            handlePinchZoom(image);
          }
        }
      } else {
        addMouseMoveEvent(image);
      }
    });
  });

  container.addEventListener('lgAfterClose', () => {
    GLOBALS.PINCH_ZOOM = [];
    const videoEle = document.getElementById('product-video');
    if (videoEle && !videoEle.classList.contains('d-none')) {
      const playButton = document.querySelector('.play-button');
      if (playButton) {
        if (playButton.classList.contains('d-none')) {
          playButton.classList.remove('d-none');
        }
      }
    }
  });

  if (enableZoomControls === 'true') {
    container.addEventListener('lgAfterOpen', () => {
      const thumbnailArea = document.querySelector('.lg-thumb-outer .lg-thumb.group');
      const zoomIconsWrapper = document.createElement('div');
      const searchIcon = document.createElement('i');
      const zoomIcons = {
        out: document.querySelector('.lg-toolbar .lg-zoom-out'),
        in: document.querySelector('.lg-toolbar .lg-zoom-in'),
      };

      if (zoomIcons && zoomIcons.length > 0) {
        zoomIcons.in.classList.remove('lg-icon');
        zoomIcons.out.classList.remove('lg-icon');
        zoomIcons.in.classList.add('border', 'border-primary', 'font-icon', 'icon-plus', 'text-center', 'mx-4');
        zoomIcons.out.classList.add('border', 'border-primary', 'font-icon', 'icon-minus', 'text-center', 'mx-4');
        searchIcon.classList.add('lg-zoom-icon', 'font-icon', 'icon-fa-search');

        zoomIconsWrapper.classList.add('lg-toolbar-custom');
        zoomIconsWrapper.appendChild(zoomIcons.out);
        zoomIconsWrapper.appendChild(searchIcon);
        zoomIconsWrapper.appendChild(zoomIcons.in);

        thumbnailArea.appendChild(zoomIconsWrapper);

        zoomIcons.in.addEventListener('click', () => {
          const zoomLevel = document.querySelector('.lg-current .lg-image').dataset.scale;
          if (zoomLevel > 10) {
            zoomIcons.in.classList.add('inactive');
          } else {
            zoomIcons.in.classList.remove('inactive');
          }
        });

        zoomIcons.out.addEventListener('click', () => {
          zoomIcons.in.classList.remove('inactive');
        });
      }
    });
  }
  return plugin;
};

const handleZoomOutVideo = () => {
  const currentVideoSlide = document.querySelector('.lg-current .lg-video-cont');
  if (currentVideoSlide) {
    document.querySelector('.lg-video-cont').style.height = `${window.innerHeight
      - document.querySelector('.lg-thumb-outer').offsetHeight}px`;
  }
};

const handlePinchZoom = (image) => {
  const container = document.querySelector(SELECTORS.GALLERY) || document.querySelector('.primary-images__wrapper');
  // intiate on image carousle.
  if (!container.dataset.newpdp) {
    if (!container.dataset.initialized) {
      const images = container.querySelectorAll('img');

      images.forEach((imgElement) => {
        const pinchZoomObj = new PinchZoom(imgElement, {
          draggableUnzoomed: false,
          minZoom: 1,
          setOffsetsOnce: false,
          onZoomUpdate: (zoomObj) => {
            const zoomStart = zoomObj.zoomFactor > 1 && !GLOBALS.PINCH_ZOOM_TOGGLED;
            const zoomEnd = zoomObj.zoomFactor <= 1 && GLOBALS.PINCH_ZOOM_TOGGLED;
            if (zoomStart) {
              GLOBALS.PINCH_ZOOM_TOGGLED = true;
              document.dispatchEvent(new CustomEvent(EVENTS.PINCH_ZOOM_START));
            } else if (zoomEnd) {
              GLOBALS.PINCH_ZOOM_TOGGLED = false;
              document.dispatchEvent(new CustomEvent(EVENTS.PINCH_ZOOM_END));
            }
          },
        });
        GLOBALS.PINCH_ZOOM.push(pinchZoomObj);
      });

      container.dataset.initialized = 'true';
    } else if (GLOBALS.PINCH_ZOOM.length > 0) {
      GLOBALS.PINCH_ZOOM.forEach((pinchZoomObj) => {
        pinchZoomObj.update({ type: 'resize' });
        if (pinchZoomObj.el.classList.contains('product-video-slot')) {
          setTimeout(() => {
            handleZoomOutVideo();
          }, 0);
        }
      });
    }
  } else {
    // eslint-disable-next-line no-lonely-if
    if (!isLG() && image) { // intiate on Lightgallery
      const pinchContainer = image.parentNode;
      let initialOffSet;
      const pinchZoomObj = new PinchZoom(image, {
        draggableUnzoomed: false,
        minZoom: 1,
        lockDragAxis: true,
        zoomOutFactor: 1,
        onZoomUpdate: (zoomObj) => {
          const zoomStart = zoomObj.zoomFactor > 1 && !GLOBALS.PINCH_ZOOM_TOGGLED;
          const zoomEnd = zoomObj.zoomFactor <= 1 && GLOBALS.PINCH_ZOOM_TOGGLED;
          if (zoomStart) {
            image.classList.add('zoomed-in');
            GLOBALS.PINCH_ZOOM_TOGGLED = true;
            document.dispatchEvent(new CustomEvent(EVENTS.PINCH_ZOOM_START));
          } else if (zoomEnd) {
            image.classList.remove('zoomed-in');
            GLOBALS.PINCH_ZOOM_TOGGLED = false;
            document.dispatchEvent(new CustomEvent(EVENTS.PINCH_ZOOM_END));
          }
        },
      });
      GLOBALS.PINCH_ZOOM.push(pinchZoomObj);

      image.dataset.initialized = 'true';

      const runZoomAnimation = () => {
        const zoomFactor = 2;
        pinchZoomObj.zoomFactor = zoomFactor;
        if (!initialOffSet) {
          const offsetX = (image.offsetWidth * zoomFactor - pinchContainer.offsetWidth) / 2;
          const offsetY = (image.offsetHeight * zoomFactor - pinchContainer.offsetHeight) / 2;
          initialOffSet = {
            x: offsetX,
            y: offsetY,
          };
        }

        pinchZoomObj.offset = initialOffSet;

        pinchZoomObj.update();
      };
      runZoomAnimation();

      /**
       * This functionality is for single tap zoom-in and zoom-out
       */
      let tapStartTime = 0;
      let tapStartX = 0;
      let tapStartY = 0;
      let startEventElement = null;
      const TAP_THRESHOLD = 10; // pixels
      const TAP_MAX_DURATION = 250; // milliseconds

      pinchContainer.addEventListener('touchstart', (e) => {
        tapStartTime = Date.now();
        tapStartX = e.touches[0].clientX;
        tapStartY = e.touches[0].clientY;
        startEventElement = e;
      }, { passive: true });

      pinchContainer.addEventListener('touchmove', (e) => {
        // Reset tap if moved too far
        const x = e.touches[0].clientX;
        const y = e.touches[0].clientY;
        const dx = Math.abs(x - tapStartX);
        const dy = Math.abs(y - tapStartY);
        if (dx > TAP_THRESHOLD || dy > TAP_THRESHOLD) {
          tapStartTime = 0; // Cancel potential tap
        }

        if (e.touches.length > 1 && pinchZoomObj.zoomFactor === 1) {
          e.preventDefault();
        }
      }, { passive: true });

      pinchContainer.addEventListener('touchend', (e) => {
        const tapDuration = Date.now() - tapStartTime;
        const x = e.changedTouches[0].clientX;
        const y = e.changedTouches[0].clientY;
        const dx = Math.abs(x - tapStartX);
        const dy = Math.abs(y - tapStartY);

        if (tapStartTime === 0) return;
        // This is a tap
        if (tapDuration <= TAP_MAX_DURATION && dx <= TAP_THRESHOLD && dy <= TAP_THRESHOLD) {
          if (pinchZoomObj.zoomFactor === 1) {
            pinchZoomObj.handleDoubleTap(startEventElement);
          } else if (pinchZoomObj.zoomFactor > 1) {
            pinchZoomObj.handleDoubleTap(e);
          }
        }
      }, { passive: true });
    }
  }
};

export const initImageGallery = () => {
  const imgObj = document.querySelectorAll('.zoom-image');
  const videoButton = document.querySelector('.play-button');
  const container = document.querySelector(SELECTORS.GALLERY) || document.querySelector('.primary-images__wrapper');
  let galleryId = container.getAttribute('lg-uid');
  GLOBALS.PLUGIN = lightGallery();

  if (!container.dataset.newpdp) {
    if (isLG()) {
      imgObj.forEach((item) => {
        item.addEventListener('click', () => {
          if (GLOBALS.PLUGIN && GLOBALS.PLUGIN.items) {
            GLOBALS.PLUGIN.destroy();
            galleryId = false;
          }
          if (!galleryId) {
            GLOBALS.PLUGIN = initGallery(container);
          }
        });
      });
    } else if (!isLG() && galleryId && window.lgData && window.lgData[galleryId]) {
      GLOBALS.PLUGIN.destroy();
    }
    handlePinchZoom(container);
  } else {
    imgObj.forEach((item) => {
      item.addEventListener('click', () => {
        if (GLOBALS.PLUGIN && GLOBALS.PLUGIN.items) {
          GLOBALS.PLUGIN.destroy();
          galleryId = false;
        }
        if (!galleryId) {
          GLOBALS.PLUGIN = initGallery(container);
        }
      });
    });

    if (galleryId && window.lgData && window.lgData[galleryId]) {
      if (GLOBALS.PLUGIN) {
        GLOBALS.PLUGIN.destroy();
      }
    }
  }

  if (videoButton) {
    videoButton.addEventListener('click', () => {
      if (isLG()) {
        if (GLOBALS.PLUGIN && GLOBALS.PLUGIN.items) {
          GLOBALS.PLUGIN.destroy();
        }
        GLOBALS.PLUGIN = initGallery(container);
      }
      videoPlayer();
    });
  }
};

window.addEventListener('resize', () => {
  if (GLOBALS.PLUGIN && GLOBALS.PLUGIN.lGalleryOn) {
    GLOBALS.PLUGIN.destroy();
  }
});

export const imageCarousel = () => {
  document.querySelectorAll('.custom-gallery').forEach((carouselElement, galleryIndex) => {
    const thumbWrapper = carouselElement.querySelector('.thumbs-wrapper');
    const thumbsInner = thumbWrapper.querySelector('.thumbs-inner');
    const thumbs = thumbsInner.querySelectorAll('img');
    const arrowUp = thumbWrapper.querySelector('.arrow-up');
    const arrowDown = thumbWrapper.querySelector('.arrow-down');
    const arrowLeft = carouselElement.querySelector('.arrow-left');
    const arrowRight = carouselElement.querySelector('.arrow-right');
    const mainGalleryInner = carouselElement.querySelector('.main-gallery-inner');
    const mainItems = mainGalleryInner.querySelectorAll('a');
    const carouselIndicators = carouselElement.querySelectorAll('.carousel-indicators li');

    let currentThumbY = 0;
    let activeIndex = 0;
    let isDraggingMain = false;

    let isDraggingThumb = false;
    let startX; let startY; let startTime;

    const minThumbY = () => -(thumbsInner.scrollHeight - thumbWrapper.clientHeight);

    // Simple reusable function to preload next 2 and previous 2 slide images
    const preloadImages = (currentIndex, items) => {
      const totalSlides = items.length;
      const getWrappedIndex = index => (index + totalSlides) % totalSlides;
      const preloadIndices = [
        getWrappedIndex(currentIndex + 1),
        getWrappedIndex(currentIndex + 2),
        getWrappedIndex(currentIndex - 1),
        getWrappedIndex(currentIndex - 2),
      ];

      preloadIndices.forEach((idx) => {
        const preloadItem = items[idx];
        if (preloadItem) {
          const img = preloadItem.querySelector('img');

          if (img) {
            if (img.complete && img.naturalWidth > 0) {
              return;
            }
            const src = img.dataset && img.dataset.src ? img.dataset.src : img.src;
            if (src) {
              const preloader = new window.Image();
              preloader.src = src;
            }
          }
        }
      });
    };

    // Preload first 4 images on page load
    const preloadInitialImages = (items, count = 4) => {
      const totalSlides = items.length;
      const preloadCount = Math.min(count, totalSlides); // Don't exceed total images
      const startIndex = 2; // Start from 3rd image (index 2) since first 2 are already loaded

      for (let i = startIndex; i < startIndex + preloadCount; i++) {
        const item = items[i];
        if (item) {
          const img = item.querySelector('img');
          if (img) {
            const src = img.dataset && img.dataset.src ? img.dataset.src : img.src;
            if (src) {
              const preloader = new window.Image();
              preloader.src = src;
            }
          }
        }
      }
    };

    const centerActiveThumb = () => {
      const thumbTop = thumbs[activeIndex].offsetTop;
      const thumbHeight = thumbs[activeIndex].offsetHeight;
      const centerY = thumbTop - thumbWrapper.clientHeight / 2 + thumbHeight / 2;
      currentThumbY = Math.min(0, Math.max(-centerY, minThumbY()));
      thumbsInner.style.transform = `translateY(${currentThumbY}px)`;
      // eslint-disable-next-line no-unused-expressions
      (currentThumbY <= 10 && currentThumbY >= 0)
        ? arrowUp.classList.add('d-none')
        : arrowUp.classList.remove('d-none');
      // eslint-disable-next-line no-unused-expressions, max-len
      -currentThumbY + thumbWrapper.clientHeight >= thumbsInner.clientHeight - 10 ? arrowDown.classList.add('d-none') : arrowDown.classList.remove('d-none');
    };

    const updateMainGallery = (index) => {
    // eslint-disable-next-line no-param-reassign
      if (index < 0) index = mainItems.length - 1;
      // eslint-disable-next-line no-param-reassign
      if (index >= mainItems.length) index = 0;
      activeIndex = index;
      mainItems.forEach((item, i) => item.classList.toggle('active', i === activeIndex));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === activeIndex));
      carouselIndicators.forEach((thumb, i) => thumb.classList.toggle('active', i === activeIndex));
      centerActiveThumb();

      // Preload next 2 and previous 2 slide images for desktop carousel
      preloadImages(activeIndex, mainItems);
    };

    // Preload first 5 images when gallery initializes
    preloadInitialImages(mainItems, 4);

    $(carouselElement).on('slide.bs.carousel', (e) => {
      carouselElement.classList.add('carousel');
      const carouselItems = carouselElement.querySelectorAll('.carousel-item');
      const totalSlides = carouselItems.length;
      const carouselactiveIndex = [...carouselItems]
        .findIndex(item => item.classList.contains('active'));

      // Preload next 2 and previous 2 slide images
      preloadImages(carouselactiveIndex, carouselItems);

      // Trying to go next on last slide
      if (carouselactiveIndex === totalSlides - 1 && e.direction === 'left') {
        e.preventDefault(); // block last to first
      }

      // Trying to go prev on first slide
      if (carouselactiveIndex === 0 && e.direction === 'right') {
        e.preventDefault(); // block first to last
      }
    });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => updateMainGallery(index));
    });

    arrowLeft.addEventListener('click', () => {
      updateMainGallery(activeIndex - 1);
    });

    arrowRight.addEventListener('click', () => {
      updateMainGallery(activeIndex + 1);
    });

    const handleMainEnd = (endX) => {
      if (!isDraggingMain) return;
      const deltaX = endX - startX;
      const velocity = Math.abs(deltaX) / (Date.now() - startTime);
      mainGalleryInner.style.transition = window.innerWidth <= 768 ? 'transform 0.3s ease' : 'none';
      if (deltaX > 50 || (velocity > 0.5 && deltaX > 0)) updateMainGallery(activeIndex - 1);
      else if (deltaX < -50 || (velocity > 0.5 && deltaX < 0)) updateMainGallery(activeIndex + 1);
      isDraggingMain = false;
    };

    mainGalleryInner.addEventListener('mousedown', (e) => {
      isDraggingMain = true;
      startX = e.clientX;
      startTime = Date.now();
    });
    mainGalleryInner.addEventListener('touchstart', (e) => {
      isDraggingMain = true;
      startX = e.touches[0].clientX;
      startTime = Date.now();
    });
    mainGalleryInner.addEventListener('mouseup', e => handleMainEnd(e.clientX));
    mainGalleryInner.addEventListener('mouseleave', (e) => {
      if (isDraggingMain) handleMainEnd(e.clientX);
    });
    mainGalleryInner.addEventListener('slid.bs.carousel', (e) => {
      activeIndex = e.to;

      thumbs.forEach((thumb, i) => thumb.classList.toggle('active', i === activeIndex));
      carouselIndicators.forEach((ind, i) => ind.classList.toggle('active', i === activeIndex));
      centerActiveThumb();
    });

    const showHideThumbnailsArrows = () => {
      const transformValue = window.getComputedStyle(thumbsInner).transform;
      const lastThumb = document.querySelector('.thumbs-inner .thumb:last-child');
      const thumbsWrapper = document.querySelector('.thumbs-wrapper');
      const firstVisible = currentThumbY === 0;
      if (transformValue && lastThumb) {
        // eslint-disable-next-line max-len
        arrowDown.classList.toggle('d-none', lastThumb.offsetTop + lastThumb.offsetHeight <= thumbsWrapper.offsetHeight - currentThumbY);
        arrowUp.classList.toggle('d-none', firstVisible);
      } else {
        arrowUp.classList.add('d-none');
        arrowDown.classList.add('d-none');
      }
    };

    const mainImage = carouselElement.querySelector('.carousel-item img.zoom-image');
    const mainImageHeight = mainImage && mainImage.clientHeight;
    const showArrows = mainImageHeight < thumbsInner.clientHeight;

    if (showArrows) {
      const handleThumbEnd = (endY) => {
        if (!isDraggingThumb) return;
        const deltaY = endY - startY;
        const velocity = Math.abs(deltaY) / (Date.now() - startTime);
        currentThumbY += deltaY;
        currentThumbY = Math.min(0, Math.max(currentThumbY, minThumbY()));
        thumbsInner.style.transform = `translateY(${currentThumbY}px)`;
        if (deltaY > 50 || (velocity > 0.5 && deltaY > 0)) currentThumbY = Math.min(currentThumbY + 80, 0);
        else if (deltaY < -50 || (velocity > 0.5 && deltaY < 0)) {
          currentThumbY = Math.max(currentThumbY - 80,
            minThumbY());
        }
        thumbsInner.style.transform = `translateY(${currentThumbY}px)`;
        isDraggingThumb = false;
      };

      arrowUp.addEventListener('click', () => {
        currentThumbY = Math.min(currentThumbY + 80, 0);
        thumbsInner.style.transform = `translateY(${currentThumbY}px)`;
        showHideThumbnailsArrows();
      });
      arrowDown.addEventListener('click', () => {
        currentThumbY = Math.max(currentThumbY - 80, minThumbY());
        thumbsInner.style.transform = `translateY(${currentThumbY}px)`;
        showHideThumbnailsArrows();
      });

      thumbsInner.addEventListener('mousedown', (e) => {
        isDraggingThumb = true;
        startY = e.clientY;
        startTime = Date.now();
        showHideThumbnailsArrows();
      });
      thumbsInner.addEventListener('touchstart', (e) => {
        isDraggingThumb = true;
        startY = e.touches[0].clientY;
        startTime = Date.now();
        showHideThumbnailsArrows();
      });
      // eslint-disable-next-line no-use-before-define
      thumbsInner.addEventListener('mouseup', e => handleThumbEnd(e.clientY), showHideThumbnailsArrows());
      thumbsInner.addEventListener('mouseleave', (e) => {
        if (isDraggingThumb) handleThumbEnd(e.clientY);
      });
      // eslint-disable-next-line max-len
      thumbsInner.addEventListener('touchend', e => handleThumbEnd(e.changedTouches[0].clientY), showHideThumbnailsArrows());
    } else {
      arrowUp.classList.add('d-none');
      // eslint-disable-next-line max-len
      arrowDown.classList.add('d-none');
    }

    function waitForAllThumbnailsToLoad(callback) {
      const thumbnails = thumbsInner.querySelectorAll('img.thumb');

      if (!thumbnails.length) {
        callback();
        return;
      }

      let loadedCount = 0;

      thumbnails.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
          loadedCount++;
        } else {
          img.addEventListener('load', () => {
            loadedCount++;
            if (loadedCount === thumbnails.length) {
              callback();
            }
          }, { once: true });
        }
      });

      if (loadedCount === thumbnails.length) {
        callback();
      }
    }

    // Scroll-based arrow visibility
    // Function to check if thumbnails exceed 7 and update arrow visibility
    const updateArrowVisibility = () => {
      const image = carouselElement.querySelector('.carousel-item img.zoom-image');
      let carouselHeight = image && image.clientHeight;
      let hideArrows = carouselHeight > thumbsInner.clientHeight;
      if (carouselHeight > 20) {
        thumbWrapper.style.maxHeight = `${carouselHeight}px`;
      }
      if (!hideArrows) {
        waitForAllThumbnailsToLoad(() => {
          showHideThumbnailsArrows();
        });
      }
      image.addEventListener('load', () => {
        carouselHeight = image.clientHeight;
        if (carouselHeight > 20) {
          thumbWrapper.style.maxHeight = `${carouselHeight}px`;
        }
        hideArrows = carouselHeight > thumbsInner.clientHeight;
        if (!hideArrows) {
          waitForAllThumbnailsToLoad(() => {
            showHideThumbnailsArrows();
          });
        }
      });
    };

    updateArrowVisibility();
    window.addEventListener('load', () => {
      updateArrowVisibility(); // or await updateArrowVisibility() if using async IIFE
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // Call your initializers
  if (typeof initImageGallery === 'function') initImageGallery();
  if (typeof imageCarousel === 'function') imageCarousel();
  document.addEventListener('resize', () => {
    if (typeof initImageGallery === 'function') initImageGallery();
    if (typeof imageCarousel === 'function') imageCarousel();
  });
});
